// This is a copy of the RadioGroup component from the formik-mui package - could not use the full package as it was causing errors

import * as React from "react";
import MuiRadioGroup, {
  RadioGroupProps as MuiRadioGroupProps,
} from "@mui/material/RadioGroup";
import { FieldProps } from "formik";

export interface FormikMuiRadioGroupProps
  extends FieldProps,
    Omit<MuiRadioGroupProps, "name" | "value"> {}

export function fieldToRadioGroup({
  field: { onBlur: fieldOnBlur, ...field },
  form,
  onBlur,
  ...props
}: FormikMuiRadioGroupProps): MuiRadioGroupProps {
  return {
    onBlur:
      onBlur ??
      function (e) {
        fieldOnBlur(e ?? field.name);
      },
    ...field,
    ...props,
  };
}

export function FormikMuiRadioGroup(props: FormikMuiRadioGroupProps) {
  return <MuiRadioGroup {...fieldToRadioGroup(props)} />;
}
